import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=ef6962f8"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports